import React, { useState } from 'react';
import ToyCard from '../blocks/ToyCard';
import nextIcon from '../icons/next.svg';
import previousIcon from '../icons/previous.svg';
import '../styles/HorizontalCatalog.css';
import PosterCard from '../blocks/PosterCard';
import CubesMagnCard from '../blocks/CubesMagnCard';

const HorizontalCatalog = ({ products, loading, hasMore, onLoadMore, onCardClick, itemsPerSlide = 3 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const maxIndex = Math.max(0, products.length - itemsPerSlide);

  const handlePrev = () => {
    setCurrentIndex(prev => Math.max(0, prev - itemsPerSlide));
  };

  const handleNext = () => {
    const nextIndex = currentIndex + itemsPerSlide;
    if (nextIndex <= maxIndex) {
      setCurrentIndex(nextIndex);
    }
    // Подгружаем следующую страницу, если близко к концу
    if (nextIndex + itemsPerSlide >= products.length && hasMore && !loading) {
      onLoadMore();
    }
  };

  const handleTouchStart = (e) => setTouchStart(e.targetTouches[0].clientX);
  const handleTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > 50) handleNext();
    else if (distance < -50) handlePrev();
    setTouchStart(null);
    setTouchEnd(null);
  };

  const visibleProducts = products.slice(currentIndex, currentIndex + itemsPerSlide);

  return (
    <div className="horizontalCatalogContainer">
      {products?.length > itemsPerSlide ? <button className="sliderButton prevButton" onClick={handlePrev} disabled={currentIndex === 0}>
          <img src={previousIcon} alt="Назад" />
        </button> : null}
      <div
        className="horizontalCatalogSlider"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="sliderTrack">
          {visibleProducts.map(product => (
            <div
              key={product._id}
              className="sliderItem"
              style={{ flex: `0 0 ${100 / itemsPerSlide}%` }}
            >   
            {product.category === 'Постеры' ?
                <PosterCard product={product} onClick={() => onCardClick(product)} /> : 
                <CubesMagnCard product={product} onClick={() => onCardClick(product)} />
            }
            </div>
          ))}
          {loading && <div className="sliderLoading">Загрузка...</div>}
        </div>
      </div>

      {products?.length > itemsPerSlide ? <button
        className="sliderButton nextButton"
        onClick={handleNext}
        disabled={(currentIndex >= maxIndex && !hasMore) || loading}
      >
        <img src={nextIcon} alt="Вперёд" />
      </button> : null }
    </div>
  );
};

export default HorizontalCatalog;